import { defineStore } from 'pinia';
export const useBridgeCacheStore = defineStore('bridge-cache', {
    state() {
        return {
            appStatusBarHeight: 0,
            pageSource: '',
        };
    },
    actions: {
        setStatusBarHeight(osInfo) {
            const baseHeight = 44;
            if (osInfo && osInfo.safeAreaInsets) {
                const statusBarPixels = Number(osInfo.safeAreaInsets.top);
                const isAndroid = osInfo.systemName === 'android';
                const statusBarHeight = isAndroid
                    ? statusBarPixels / window.devicePixelRatio
                    : statusBarPixels;
                this.appStatusBarHeight = statusBarHeight;
                console.log('---osInfo--->>>', osInfo, statusBarHeight);
            }
            //   return baseHeight
        },
        getStatusBarHeight() {
            return this.appStatusBarHeight;
        },
        setPageSource(source) {
            this.pageSource = source;
        },
    },
});
